<script>
import service from '@/service';

export default {
	methods: {
		showModal: function (id, opomba, akcijski) {
			this.item_id = id;
			this.opomba = opomba;
			this.akcijski = akcijski;
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault()
			if (this.item_id != null && this.opomba != null) {
				service.urediOpomboVozilo(this.item_id, this.opomba, this.akcijski)
					.then(response => {
						this.$refs.modal.hide();
						this.$emit('opomba-success');
					})
					.catch(error => {
						if (error) {
							console.log(error);
						}
					});
			}
		}
	},
	data: function () {
		return {
			item_id: null,
			opomba: '',
			akcijski: 0
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Opomba vozila" class="modal-primary" ok-title="Posodobi" cancel-title="Prekliči" @ok="onOkModal">
		<b-row>
			<b-col>
				<b-form-group>
					<label for="opomba">Opomba</label>
					<b-form-input id="opomba"
						type="text"
						v-model="opomba"
						max="5000"></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<label for="akcijski">Akcijski:</label>
			</b-col>
			<b-col>
				<b-form-group>
					<b-form-checkbox id="akcijski"
						v-model="akcijski"
						value="1"
						unchecked-value="0"></b-form-checkbox>
				</b-form-group>
			</b-col>
			<b-col></b-col>
			<b-col></b-col>
		</b-row>
	</b-modal>
</template>
<style>
</style>


// WEBPACK FOOTER //
// src/components/OpombaVozilaModal.vue